import * as Yup from 'yup';

export function riderProfileSchema() {
  return Yup.object().shape({
    firstName: Yup.string().required('Required Field'),
    lastName: Yup.string().required('Required Field'),
    dateOfBirth: Yup.date().typeError('Required Field'),
    gender: Yup.string().required('Required Field'),
    category: Yup.string().nullable().required('Required Field'),
    mobilePhoneNumber: Yup.string()
      .test('valid-phone-number', '*Incorrect formatting', (phoneNumber) =>
        phoneNumber ? /^[0-9]{10}$/.test(phoneNumber) : true
      )
      .test(
        'start-with-zero',
        'Phone number can not begin with 0',
        (phoneNumber) => !(phoneNumber && phoneNumber[0] === '0')
      ),
    email: Yup.string().email().nullable(),
    photosAttributes: Yup.array().of(
      Yup.object().shape({
        attachment: Yup.mixed().test('fileSize', 'Photo size is greater than 10MB.', (value) => {
          if (!value?.length) {
            return true;
          }

          return value[0].size <= 10000000;
        }),
      })
    ),
  });
}

export function riderProfileSchemaV2(shouldValidateInvoiceGroup: boolean) {
  return Yup.object().shape({
    firstName: Yup.string().required('Required Field'),
    lastName: Yup.string().required('Required Field'),
    dateOfBirth: Yup.date().typeError('Required Field'),
    gender: Yup.string().required('Required Field'),
    category: Yup.string().nullable().required('Required Field'),
    mobilePhoneNumber: Yup.string()
      .test('valid-phone-number', '*Incorrect formatting', (phoneNumber) =>
        phoneNumber ? /^[0-9]{10}$/.test(phoneNumber) : true
      )
      .test(
        'start-with-zero',
        'Phone number can not begin with 0',
        (phoneNumber) => !(phoneNumber && phoneNumber[0] === '0')
      ),
    email: Yup.string().email().nullable(),
    invoiceGroupId: shouldValidateInvoiceGroup
      ? Yup.number().nullable().required('Required Field')
      : Yup.number().nullable(),
    photosAttributes: Yup.array().of(
      Yup.object().shape({
        attachment: Yup.mixed().test('fileSize', 'Photo size is greater than 10MB.', (value) => {
          if (!value?.length) {
            return true;
          }

          return value[0].size <= 10000000;
        }),
      })
    ),
  });
}
